import React, {useState} from 'react';

import AnnotationField from '../Components/AnnotationField.jsx';
import { Box } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { Button, FormControl, Modal } from '@mui/material';
import { useSelector } from 'react-redux';
import "./annotationEditionModal.css"
import { annotationsApi, selectFilteredAnnotations, selectViewSpec, updateAnnotations } from '../app/annotations.js';
import { useEffect } from 'react';
import { selectSelectedAnnotationIds } from '../app/interface.js'
import { selectTextAnnotations, updateTextAnnotation } from '../app/textAnnotations.js';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import {selectDynamicAnnotationFields, emptyAnnotation, selectUpdateOneFieldOfData} from '../app/annotations.js'


const EditModal = ({annotationsFields, mode}) => {
  const [searchParams] = useSearchParams();
  const inspectionId = searchParams.get("inspectionId")
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [annoTemplate, setAnnoTemplate] = useState({});
  const [fieldStatus, setFieldStatus] = useState({});
  const dynamicAnnotationsFields = useSelector(selectDynamicAnnotationFields)
  const newAnnotation = useSelector(emptyAnnotation); // New annotation with default values
  const updateOneFieldOfData = useSelector(selectUpdateOneFieldOfData)

  const updateAnnotationsApi = useSelector(annotationsApi.update)
  const annotations = useSelector(selectFilteredAnnotations)
  const textAnnotations = useSelector(selectTextAnnotations)
  const selectedAnnotationsIds = useSelector(selectSelectedAnnotationIds)
  const [selectedAnnotations, setSelectedAnnotations] = useState([])
  const view = useSelector(selectViewSpec)

  // keeps selectedAnnotations updated
  useEffect(() => {
    if (mode === "text") return;
    const selectedAnn = annotations.filter(a => selectedAnnotationsIds.includes(a.id))
    if (selectedAnn.length > 0 && open) {
      setSelectedAnnotations(selectedAnn)

      // we take first
      let template = {...newAnnotation.data}
      let field_status = {}
      annotationsFields.keys.forEach((k) => {
        let checkDiff = false;
        selectedAnn.map((a) => {
          if (a.data[k.name] !== selectedAnn[0].data[k.name])
            checkDiff = true;
        })
        if (!checkDiff){
          template[k.name] = selectedAnn[0].data[k.name]
          field_status[k.name] = "all_have_the_same_value";
        }
        else{
          field_status[k.name] = "different_values";
        }
      })
      setAnnoTemplate(template)
      setFieldStatus(field_status)
    }
  }, [selectedAnnotationsIds, open])

  // trigger by opening the edit modal on the Labels tab
  // used to fill the text field from the selected labels
  useEffect(() => {
    if (mode !== "text" || !open) return;
    const selected = textAnnotations.filter((a) => selectedAnnotationsIds.includes(a.id));
    if (selected.length === 0) return;
    setSelectedAnnotations(selected);
    const same = selected.every((a) => a.text?.value === selected[0].text?.value);
    setAnnoTemplate({ value: same ? (selected[0].text?.value ?? "") : "" });
    setFieldStatus({ value: same ? "all_have_the_same_value" : "different_values" });
  }, [mode, selectedAnnotationsIds, open, textAnnotations])

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setAnnoTemplate({})
  };

  // Custom message to tell the user wether the field will be overwritten or not
  const getAdditionalMessage = (fieldName) => {
    if (fieldStatus[fieldName] == "different_values"){
      return "⚠️ different values; kept unchanged";
    }
    else if (fieldStatus[fieldName] == "overwritten"){
      return "⚠️ will be overwritten";
    }
    else return null;
  }

  // modal set up
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    height: "80vh",
    bgcolor: 'white',
    p: 4,
  };

  if (mode === "text") return (
    <>
      <Button onClick={handleOpen}>
        <EditIcon fontSize="medium" />
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Box component="div" sx={style}>
          <div>
            <p>{selectedAnnotations.length} label{selectedAnnotations.length > 1 ? "s" : ""} selected</p>
          </div>
          <FormControl sx={{width: "100%"}}>
            <h3>Edition form</h3>
            <div className="annotation-edit-form" style={{ overflowX: 'hidden' }}>
              <div className="field-parent-div">
                <label>Text {getAdditionalMessage("value")}</label>
                <textarea
                  value={annoTemplate.value ?? ""}
                  rows={3}
                  onChange={(e) => {
                    setAnnoTemplate({ value: e.target.value });
                    setFieldStatus({ value: "overwritten" });
                  }}
                  style={{ display: 'block', width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box', marginTop: 8, fontFamily: 'inherit', resize: 'vertical' }}
                />
              </div>
            </div>
            <div className="annotation-edit-form-btns">
              <Button variant="contained" onClick={() => {
                if (fieldStatus.value !== "overwritten" || selectedAnnotations.length === 0) return;
                const value = annoTemplate.value ?? "";
                const groups = {};
                selectedAnnotations.forEach((a) => {
                  const color = a.text?.color || "#000000";
                  if (!groups[color]) groups[color] = [];
                  groups[color].push(a.id);
                });
                const entries = Object.entries(groups);
                let left = entries.length;
                entries.forEach(([color, ids]) => {
                  updateAnnotationsApi({ ids, text: { value, color }, inspectionId }, (anns) => {
                    if (anns) {
                      anns.forEach((saved) => {
                        const existing = selectedAnnotations.find((a) => a.id === saved.id);
                        if (!existing) return;
                        dispatch(updateTextAnnotation({ ...existing, text: saved.text ?? { value, color } }));
                      });
                    }
                    left -= 1;
                    if (left === 0) handleClose();
                  });
                });
              }}>
                Save
              </Button>
            </div>
          </FormControl>
          <Button onClick={handleClose} sx={{ position: "fixed", top: "10px", right: "10px" }}>
            <CloseIcon fontSize="small" />
          </Button>
        </Box>
      </Modal>
    </>
  );

  return (
    <>
      <Button onClick={handleOpen}>
        <EditIcon fontSize="medium" />
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="edit-modal-title"
        aria-describedby="edit-modal-description"
      >
        <Box component="div" sx={style} >
          <div>
            <p>{selectedAnnotations.length} Annotations selected</p>
          </div>
          <FormControl sx={{width: "100%"}}>
            <h3>Edition form</h3>
            <div className="annotation-edit-form">
            {
              annoTemplate &&
              dynamicAnnotationsFields(annoTemplate).keys.map((af) => {
                return <div className="field-parent-div" >
                  <AnnotationField key={af.name}
                  handleChange={(v) => {
                    const {updatedData, keysChanged} = updateOneFieldOfData(annoTemplate,af.name,v)
                    setAnnoTemplate(updatedData)
                    setFieldStatus({
                      ...fieldStatus,
                      ...keysChanged.reduce((acc,k) => {
                        acc[k] = "overwritten" 
                        return acc
                      },{})
                    })
                  }}
                  field={af}
                  disabled={false}
                  title_additional_message={getAdditionalMessage(af.name)}
                  currentValue={annoTemplate[af.name]}
                /></div>}
              )
            }
            </div>
            <div className='annotation-edit-form-btns'>
              <Button variant="contained" onClick={() => {
                // Prepare content of the update query:
                let query = {
                  ids: selectedAnnotationsIds,
                  data: {},
                  inspectionId: inspectionId
                };
                // In the query, we include only the fields that were displayed as "will be overwritten"
                for (let [kname, value] of Object.entries(annoTemplate)){
                  if (fieldStatus[kname] === "overwritten") query.data[kname] = value;
                }
                updateAnnotationsApi(query, (anns) => {
                  if (anns  !== null){
                    dispatch(updateAnnotations(anns));
                    handleClose();
                  }
                })
              }}>
                Save
              </Button>
            </div>
          </FormControl>
          <Button 
            onClick={handleClose}
            sx={{
              position: "fixed",
              top: "10px",
              right: "10px"
            }}
          >
            <CloseIcon fontSize="small" />
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default EditModal;